/****************************************************
 * Module Name:  RapnetLoginProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class RapnetLoginsProxy {
  static GetAllRapnetLogins = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/rapnetlogin",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static getAllRapnetLoginsMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/rapnetlogin/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckRapnetIdAvailable = (id, callback) => {
    let params = {
      rapnetid: id,
    };

    restAPICall(
      Constants.MANAGER_URL + "/rapnetlogin/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddRapnetLogins = (user, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/rapnetlogin",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(user),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateRapnetLogins = (user, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/rapnetlogin",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(user),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}